<template>
  <div>
    <template v-if="hasStreamData">
      <router-view/>
    </template>
    <template v-else>
      <NoSignalPage />
    </template>
  </div>
</template>

<script>
import NoSignalPage from '@/layouts/NoSignalPage.vue';

export default {
  components: {
    NoSignalPage,
  },
  data() {
    return {
      hasStreamData: false,
    };
  },
  async created() {
    const queryString = this.$route.query;
    if (queryString) {
      try {
        await this.loadData();
        setInterval(async () => this.loadData(), 15000);
        if (Object.prototype.hasOwnProperty.call(queryString, 'lang')) {
          await this.$store.dispatch('setLanguage', queryString.lang);
        }
      } catch (error) {
        this.hasStreamData = false;
      }
    }
  },
  methods: {
    async loadData() {
      const fleetURL = this.$route.query.url;
      const data = await (await fetch(fleetURL)).json();
      this.hasStreamData = !!data.streamkey;
      await this.$store.dispatch('setStream', data);
    },
  },
};
</script>
